/* CamiceLab – product cards: colour swatches (+N reveals all) and a Sloth-style "Scegli la taglia" quick-add drawer */
(function () {
  if (window.clCardsInit) return;
  window.clCardsInit = true;

  var T = {
    title: 'Scegli la taglia',
    close: 'Chiudi',
    details: 'Vedi tutti i dettagli e la guida alle taglie',
    soldout: 'Esaurito',
    one: 'Aggiungi al carrello',
    error: 'Ops, qualcosa è andato storto. Riprova.',
    persoLabel: 'Scrivi qui la tua personalizzazione (facoltativa):',
    persoNote: '📩 Ti mandiamo l’anteprima su WhatsApp prima della stampa.'
  };
  var cache = {};
  var dr = null;
  var st = {};
  var fmt = null;

  function money(c) {
    try {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      fmt = fmt || new Intl.NumberFormat('it-IT', { style: 'currency', currency: cur });
      return fmt.format(c / 100);
    } catch (e) {
      return (c / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function optIndex(p, re) {
    for (var i = 0; i < p.options.length; i++) {
      var n = p.options[i] && p.options[i].name ? p.options[i].name : p.options[i];
      if (re.test(String(n).trim())) return i;
    }
    return -1;
  }

  /* ---------- Card swatches ---------- */
  function swap(card, dot) {
    var im = card.querySelector('.card__media img');
    if (im && dot.dataset.src) {
      if (dot.dataset.srcset) im.srcset = dot.dataset.srcset;
      im.src = dot.dataset.src;
    }
    card.querySelectorAll('.cl-cs__dot').forEach(function (d) {
      d.classList.toggle('is-on', d === dot);
      d.setAttribute('aria-pressed', d === dot ? 'true' : 'false');
    });
  }
  function syncCard(color) {
    if (!st.card) return;
    var dots = st.card.querySelectorAll('.cl-cs__dot');
    for (var i = 0; i < dots.length; i++) {
      if (dots[i].getAttribute('aria-label') === color) {
        var box = dots[i].closest('.cl-cs');
        if (box && dots[i].classList.contains('cl-cs__dot--x')) box.classList.add('is-open');
        swap(st.card, dots[i]);
        return;
      }
    }
  }

  /* ---------- Drawer ---------- */
  function build() {
    dr = document.createElement('div');
    dr.className = 'cl-qd';
    dr.hidden = true;
    dr.innerHTML =
      '<div class="cl-qd__bg" data-cl-close></div>' +
      '<div class="cl-qd__panel" role="dialog" aria-modal="true" aria-labelledby="cl-qd-h">' +
        '<div class="cl-qd__head"><h2 class="cl-qd__h" id="cl-qd-h">' + T.title + '</h2>' +
        '<button type="button" class="cl-qd__x" data-cl-close aria-label="' + T.close + '">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>' +
        '</button></div>' +
        '<div class="cl-qd__body"></div>' +
      '</div>';
    document.body.appendChild(dr);
    dr.addEventListener('click', onDrawerClick);
    dr.addEventListener('input', function (e) {
      if (e.target && e.target.id === 'cl-qd-perso') st.persoVal = e.target.value;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && dr && !dr.hidden) close();
    });
  }
  function open() {
    dr.hidden = false;
    document.documentElement.classList.add('cl-qd-lock');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { dr.classList.add('is-open'); });
    });
    setTimeout(function () {
      var x = dr.querySelector('.cl-qd__x');
      if (x) x.focus();
    }, 320);
  }
  function close(cb) {
    if (!dr) return;
    dr.classList.remove('is-open');
    document.documentElement.classList.remove('cl-qd-lock');
    setTimeout(function () {
      dr.hidden = true;
      if (typeof cb === 'function') cb();
      else if (st.trigger) { try { st.trigger.focus(); } catch (e) {} }
    }, 280);
  }

  function render() {
    var p = st.p, ci = st.ci, si = st.si;
    var body = dr.querySelector('.cl-qd__body');
    var vs = p.variants.filter(function (v) { return ci < 0 || v.options[ci] === st.color; });
    if (si > -1) {
      var order = p.options[si].values;
      vs = vs.slice().sort(function (a, b) { return order.indexOf(a.options[si]) - order.indexOf(b.options[si]); });
    }
    var first = vs[0] || p.variants[0];
    var pic = (first && first.featured_image && first.featured_image.src) || p.featured_image;

    var h = '<div class="cl-qd__prod">' +
      (pic ? '<img class="cl-qd__img" src="' + esc(img(pic, 240)) + '" alt="" width="96" height="96">' : '') +
      '<div><p class="cl-qd__t">' + esc(p.title) + '</p>' +
      (ci > -1 ? '<p class="cl-qd__c">' + esc(st.color) + '</p>' : '') + '</div></div>';

    if (ci > -1 && p.options[ci].values.length > 1) {
      h += '<div class="cl-qd__dots">';
      p.options[ci].values.forEach(function (val) {
        var bg = st.sw[val] || '';
        var on = val === st.color;
        h += '<button type="button" class="cl-qd__dot' + (on ? ' is-on' : '') + (bg ? '' : ' cl-qd__dot--txt') + '"' +
          ' data-cl-color="' + esc(val) + '" aria-label="' + esc(val) + '" title="' + esc(val) + '" aria-pressed="' + on + '"' +
          (bg ? ' style="' + esc(bg) + '"' : '') + '>' + (bg ? '' : esc(val)) + '</button>';
      });
      h += '</div>';
    }

    if (st.perso) {
      h += '<div class="cl-qd__perso"><label class="cl-qd__plabel" for="cl-qd-perso">' + T.persoLabel + '</label>' +
        '<input class="cl-qd__pinput" id="cl-qd-perso" type="text" maxlength="150" autocomplete="off" value="' + esc(st.persoVal || '') + '">' +
        '<p class="cl-qd__pnote">' + T.persoNote + '</p></div>';
    }

    h += '<ul class="cl-qd__list">';
    vs.forEach(function (v) {
      var parts = v.options.filter(function (o, i) { return i !== ci; });
      var label = (p.has_only_default_variant || !parts.length) ? T.one : parts.join(' / ');
      var price = money(v.price) + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '');
      h += '<li><button type="button" class="cl-qd__row" data-cl-vid="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
        '<span class="cl-qd__size">' + esc(label) + '</span>' +
        '<span class="cl-qd__price">' + (v.available ? price : T.soldout) + '</span></button></li>';
    });
    h += '</ul><p class="cl-qd__err" role="alert" hidden></p>' +
      '<a class="cl-qd__more" href="' + esc(st.url) + '">' + T.details + '</a>';
    body.innerHTML = h;
  }

  function onDrawerClick(e) {
    if (e.target.closest('[data-cl-close]')) { close(); return; }
    var d = e.target.closest('[data-cl-color]');
    if (d) {
      st.color = d.getAttribute('data-cl-color');
      render();
      syncCard(st.color);
      return;
    }
    var r = e.target.closest('[data-cl-vid]');
    if (r && !r.disabled && !st.busy) add(r);
  }

  function add(row) {
    st.busy = true;
    row.classList.add('is-busy');
    var err = dr.querySelector('.cl-qd__err');
    if (err) err.hidden = true;
    var cd = document.querySelector('cart-drawer');
    var item = { id: Number(row.getAttribute('data-cl-vid')), quantity: 1 };
    var pv = st.perso && st.persoVal ? st.persoVal.trim() : '';
    if (pv) item.properties = { 'Personalizzazione': pv };
    var payload = { items: [item] };
    if (cd && typeof cd.getSectionsToRender === 'function') {
      payload.sections = cd.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      payload.sections_url = window.location.pathname;
    }
    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || T.error);
        close(function () {
          if (cd && typeof cd.renderContents === 'function') {
            cd.classList.remove('is-empty');
            cd.renderContents(res);
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        });
      })
      .catch(function (e) {
        if (err) { err.textContent = (e && e.message) || T.error; err.hidden = false; }
      })
      .then(function () {
        st.busy = false;
        row.classList.remove('is-busy');
      });
  }

  function getProduct(url) {
    if (cache[url]) return Promise.resolve(cache[url]);
    return fetch(url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); })
      .then(function (p) { cache[url] = p; return p; });
  }

  function openFor(card, url, trigger, perso) {
    if (!dr) build();
    url = url.split('#')[0].split('?')[0];
    st = { url: url, card: card, trigger: trigger, sw: {}, perso: !!perso, persoVal: '' };
    var picked = null;
    if (card) {
      card.querySelectorAll('.cl-cs__dot').forEach(function (d) {
        var n = d.getAttribute('aria-label');
        st.sw[n] = d.getAttribute('style') || '';
        if (d.classList.contains('is-on')) picked = n;
      });
    }
    var spin = trigger.querySelector('.loading__spinner');
    trigger.classList.add('loading');
    if (spin) spin.classList.remove('hidden');
    getProduct(url)
      .then(function (p) {
        st.p = p;
        st.ci = optIndex(p, /^(colore|colori|color|colour)$/i);
        st.si = optIndex(p, /^(taglia|taglie|size)$/i);
        if (st.ci > -1) {
          var vals = p.options[st.ci].values;
          if (!picked || vals.indexOf(picked) < 0) {
            var fa = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
            picked = fa.options[st.ci];
          }
          st.color = picked;
        }
        render();
        open();
      })
      .catch(function () { window.location.href = url; })
      .then(function () {
        trigger.classList.remove('loading');
        if (spin) spin.classList.add('hidden');
      });
  }

  /* ---------- Click handling ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var more = e.target.closest('.cl-cs__more');
    if (more) {
      e.preventDefault();
      e.stopPropagation();
      var box = more.closest('.cl-cs');
      if (box) box.classList.add('is-open');
      return;
    }

    var dot = e.target.closest('.cl-cs__dot');
    if (dot) {
      e.preventDefault();
      e.stopPropagation();
      var c = dot.closest('.card-wrapper');
      if (c) swap(c, dot);
      return;
    }

    var btn = e.target.closest('.cl-qa .quick-add__submit');
    if (btn) {
      var wrap = btn.closest('.cl-qa');
      var card = btn.closest('.card-wrapper');
      var link = card && card.querySelector('a[href*="/products/"]');
      var url = wrap.getAttribute('data-cl-url') || (link && link.getAttribute('href'));
      if (!url) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      openFor(card, url, btn, /personaliz/i.test(wrap.getAttribute('data-cl-tpl') || ''));
    }
  }, true);
})();